import { createContext, useContext, useState, useCallback } from "react";

const LanguageContext = createContext();

export const useLang = () => useContext(LanguageContext);

const UI = {
  en: {
    nav_services: "Services",
    nav_work: "Our Work",
    nav_about: "About",
    nav_contact: "Contact",
    nav_estimate: "Free Estimate",
    call_now: "Call Now",
    hero_cta: "Get a Free Estimate",
    hero_call: "Call 540-314-1957",
    scroll: "Scroll",
    services_kicker: "What We Do",
    services_title: "Services",
    work_kicker: "Selected Work",
    work_title: "The Portfolio",
    work_empty: "Project photos coming soon.",
    about_kicker: "Who We Are",
    estimate_kicker: "Get Started",
    estimate_title: "Request a Free Estimate",
    estimate_sub: "Tell us about your project. We respond fast — usually the same day.",
    form_name: "Full Name",
    form_phone: "Phone",
    form_email: "Email (optional)",
    form_service: "Service Needed",
    form_message: "Describe your project",
    form_submit: "Send Request",
    form_sending: "Sending...",
    form_success: "Thanks! We'll reach out shortly.",
    form_error: "Something went wrong. Please call us instead.",
    select_service: "Select a service",
    contact_title: "Get In Touch",
    hours: "Hours",
    area: "Service Area",
    rights: "All rights reserved.",
    admin: "Admin",
    nav_reviews: "Reviews",
    reviews_kicker: "What Clients Say",
    reviews_title: "Reviews",
    reviews_based: "Based on Google reviews",
    reviews_cta: "Leave a Review on Google",
    reviews_read: "Read all reviews",
  },
  es: {
    nav_services: "Servicios",
    nav_work: "Trabajos",
    nav_about: "Nosotros",
    nav_contact: "Contacto",
    nav_estimate: "Presupuesto Gratis",
    call_now: "Llamar",
    hero_cta: "Presupuesto Gratis",
    hero_call: "Llame 540-314-1957",
    scroll: "Bajar",
    services_kicker: "Lo Que Hacemos",
    services_title: "Servicios",
    work_kicker: "Trabajos Destacados",
    work_title: "El Portafolio",
    work_empty: "Fotos de proyectos próximamente.",
    about_kicker: "Quiénes Somos",
    estimate_kicker: "Empecemos",
    estimate_title: "Solicite un Presupuesto Gratis",
    estimate_sub: "Cuéntenos sobre su proyecto. Respondemos rápido — usualmente el mismo día.",
    form_name: "Nombre Completo",
    form_phone: "Teléfono",
    form_email: "Correo (opcional)",
    form_service: "Servicio Requerido",
    form_message: "Describa su proyecto",
    form_submit: "Enviar Solicitud",
    form_sending: "Enviando...",
    form_success: "¡Gracias! Nos comunicaremos pronto.",
    form_error: "Algo salió mal. Por favor llámenos.",
    select_service: "Seleccione un servicio",
    contact_title: "Contáctenos",
    hours: "Horario",
    area: "Área de Servicio",
    rights: "Todos los derechos reservados.",
    admin: "Admin",
    nav_reviews: "Reseñas",
    reviews_kicker: "Lo Que Dicen Los Clientes",
    reviews_title: "Reseñas",
    reviews_based: "Basado en reseñas de Google",
    reviews_cta: "Deja tu Reseña en Google",
    reviews_read: "Ver todas las reseñas",
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");
  const toggle = useCallback(() => setLang((l) => (l === "en" ? "es" : "en")), []);
  const t = useCallback((key) => UI[lang][key] ?? key, [lang]);
  const pick = useCallback((obj, base) => (obj ? obj[`${base}_${lang}`] ?? obj[`${base}_en`] ?? "" : ""), [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, pick }}>
      {children}
    </LanguageContext.Provider>
  );
}
